import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid2,
  IconButton,
  Stack,
  Switch,
} from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import MaterialButton from "../../../components/MaterialButton";
import DashboardFooter from "../../../layoutcontainers/DashboardLayout/components/Footer";
import { fetchData, fetchDataById, postData, putData } from "../../../services";
import { useEffect, useReducer, useState } from "react";
import { handelChange } from "../../../reducers/formReducer";
import MaterialSelect from "../../../components/MasterSelect";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";

const initialState = {
  generalPincode: {},
  generalPincodeErr: "unchecked",
  generalInsurer: {},
  generalInsurerErr: "unchecked",
  insurerCity: {},
  insurerCityErr: "unchecked",
  code: "",
  codeErr: "unchecked",
  pincode: "",
  pincodeErr: "unchecked",
  active: true,
};

const InsurerPincodeFrom = () => {
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();
  const [state, dispatch] = useReducer(handelChange, initialState);
  const [dropdown, setDropdown] = useState({
    cityId: [],
    insurer: [],
    pincodeId: [],
  });

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const Id = searchParams.get("id");
  const pageType = searchParams.get("pageType");

  const pageMode =
    pageType === "view" ? "view" : pageType === "edit" ? "edit" : "add";

  useEffect(() => {
    const fetchPincodeList = async () => {
      setCircleLoading(true);
      try {
        const response = await fetchData(`/reference/general/pincode?dropdown=true`);

        setDropdown((prev) => ({
          ...prev,
          pincodeId: response?.data?.items?.map((item) => ({
            value: item?.id,
            label: item?.pincode,
          })),
        }));
      } catch (error) {
        console.error("Error Fetching City:", error);
        showSnackbar(error?.response?.data?.message || "Network Error", "error");
      } finally {
        setCircleLoading(false);
      }
    };
    const fetchInsurerList = async () => {
      setCircleLoading(true);
      try {
        const response = await fetchData(
          `/reference/general/insurer-master?dropdown=true`
        );

        setDropdown((prev) => ({
          ...prev,
          insurer: response?.data?.items?.map((item) => ({
            value: item?.id,
            label: item?.companyName,
          })),
        }));
      } catch (error) {
        console.error("Error Fetching Countries:", error);
        showSnackbar(error?.response?.data?.message || "Network Error", "error");
      } finally {
        setCircleLoading(false);
      }
    };
    const fetchInsurerCityList = async () => {
      setCircleLoading(true);
      try {
        const response = await fetchData(`/reference/insurer/city?dropdown=true`);

        setDropdown((prev) => ({
          ...prev,
          cityId: response?.data?.items?.map((item) => ({
            value: item?.id,
            label: item?.name,
          })),
        }));
      } catch (error) {
        console.error("Error Fetching Countries:", error);
        showSnackbar(error?.response?.data?.message || "Network Error", "error");
      } finally {
        setCircleLoading(false);
      }
    };
    fetchPincodeList();
    fetchInsurerList();
    fetchInsurerCityList();
  }, []);

  useEffect(() => {
    const fetchCityById = async () => {
      setCircleLoading(true);
      try {
        const data = await fetchDataById(`/reference/insurer/pincode/${Id}`);
        const responseData = data?.data?.pincode;

        if (data?.success) {
          dispatch({
            type: "bulkUpdate",
            payload: {
              generalCity: {
                value: responseData?.gCityId,
                label: responseData?.gCityName,
              },

              generalInsurer: {
                value: responseData?.gInsurerId,
                label: responseData?.gInsurerName,
              },

              insurerDistrict: {
                value: responseData?.district?.id,
                label: responseData?.district?.name,
              },
              insurerCity: {
                value: responseData?.city?.id,
                label: responseData?.city?.name,
              },
              generalPincode:{
                value: responseData?.gPincodeId,
                label: responseData?.gPincode,
              },
              Pincode: responseData?.pinCode || "",
              pincodeErr : responseData?.pinCode ? "success" : "unchecked",
              code: responseData?.code || "",
              name: responseData?.name || "",
              active: responseData?.isActive,
            },
          });
        }
      } catch (error) {
        console.error("Error fetching data by ID:", error);
        showSnackbar(error?.response?.data?.message || "Network Error", "error");
      } finally {
        setCircleLoading(false);
      }
    };
    if (Id) {
      fetchCityById();
    }
  }, [Id]);

  const handelSubmit = async () => {
    const payload = {
      gInsurerId: state?.generalInsurer?.value,
      gPincodeId: state?.generalPincode?.value,
      code: state?.code,
      pinCode: state?.pincode,
      iCityId: state?.insurerCity?.value,
      isActive: state?.active,
    };
    if (pageMode === "edit") {
      try {
        setCircleLoading(true);
        const response = await putData(`/reference/insurer/pincode/${Id}`, payload);
        const responseMessage = response?.message;
        if (response?.success) {
          showSnackbar(responseMessage, "success");
          navigate("/insurer-master/insurer-pincode");
        } else {
          showSnackbar(responseMessage, "error");
        }
      } catch (error) {
        console.error("Error Submitting Data",error);
        showSnackbar(error?.response?.data?.message || "Network Error", "error");
      } finally {
        setCircleLoading(false);
      }
    } else {
      try {
        setCircleLoading(true);
        const response = await postData("/reference/insurer/pincode", payload);
        const responseMessage = response?.message;
        if (response?.success) {
          showSnackbar(responseMessage, "success");
          navigate("/insurer-master/insurer-pincode");
        } else {
          showSnackbar(responseMessage, "error");
        }
      } catch (error) {
        console.error("Error Submitting Data",error);
        showSnackbar(error?.response?.data?.message || 'Network Error', "error");
      } finally {
        setCircleLoading(false);
      }
    }
  };

  const checkAllFields = () => {
    let allowSubmit = false;

    if (
      state.generalPincodeErr === "success" &&
      state.generalInsurerErr === "success" &&
      state.insurerCityErr === "success" &&
      state.codeErr === "success" &&
      state.pincodeErr === "success"
    ) {
      allowSubmit = false;
    } else {
      allowSubmit = true;
    }

    return allowSubmit;
  };

  return (
    <>
      <DashboardLayout>
        <Card sx={{ minHeight: 500 }}>
          <CardHeader
            title={
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <IconButton
                    onClick={() => navigate("/insurer-master/insurer-pincode")}
                  >
                    <ArrowBack />
                  </IconButton>
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Insurer PIN Code Details
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                      Enter New PIN Code Details from around the world according to the Insurer.
                    </MaterialTypography>
                  </Stack>
                </Stack>
              </Stack>
            }
          />

          <CardContent>
            <Grid2 container spacing={2}>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    General Insurer <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="generalInsurer"
                  options={dropdown?.insurer}
                  value={state?.generalInsurer}
                  onChange={(e) =>
                    dispatch({
                      type: "Select",
                      value: e,
                      name: "generalInsurer",
                    })
                  }
                  success={state?.generalInsurerErr === "success"}
                  error={state.generalInsurerErr === "error"}
                  isDisabled={pageMode === "view"}
                />
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    General PIN Code <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  options={dropdown?.pincodeId}
                  value={state?.generalPincode}
                  onChange={(e) =>
                    dispatch({
                      type: "Select",
                      value: e,
                      name: "generalPincode",
                    })
                  }
                  success={state?.generalPincodeErr === "success"}
                  error={state.generalPincodeErr === "error"}
                  isDisabled={pageMode === "view"}
                />
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Insurer City <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  options={dropdown?.cityId}
                  value={state?.insurerCity}
                  onChange={(e) =>
                    dispatch({
                      type: "Select",
                      value: e,
                      name: "insurerCity",
                    })
                  }
                  success={state?.insurerCityErr === "success"}
                  error={state?.insurerCityErr === "error"}
                  isDisabled={pageMode === "view"}
                />
              </Grid2>

              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Code <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="code"
                  placeholder="eg. PIN088"
                  value={state?.code}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "code",
                      type: "input",
                      regex: "^([\\s\\S]{1,20})$",
                    })
                  }
                  success={state?.codeErr === "success"}
                  error={state.codeErr === "error"}
                  disabled={pageMode === "view"}
                />
                {state.codeErr === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Code should be a minimum 1 character & maximum 20
                      characters long.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    PIN Code <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="pincode"
                  value={state?.Pincode}
                  placeholder="eg. 600 088"
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "pincode",
                      type: "input",
                      regex: "^[0-9][0-9\- ]{2,9}$",
                    })
                  }
                  success={state?.pincodeErr === "success"}
                  error={state.pincodeErr === "error"}
                  disabled={pageMode === "view"}
                />
                {state.pincodeErr === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      PIN Code should be a minimum 1 character & maximum 10
                      characters long.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>

              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Active
                  </MaterialTypography>
                </MaterialBox>
                <FormControlLabel
                  control={
                    <Switch
                      checked={state?.active}
                      onChange={() =>
                        dispatch({
                          type: "switch",
                          name: "active",
                          value: !state?.active,
                        })
                      }
                      color="primary"
                      disabled={pageMode === "view"}
                    />
                  }
                  label={
                    <MaterialTypography variant="caption" fontWeight="bold">
                      {state?.active ? "Active" : "Inactive"}
                    </MaterialTypography>
                  }
                  sx={{ marginLeft: 0 }}
                />
              </Grid2>
            </Grid2>
          </CardContent>
          <MaterialBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            {pageMode !== "view" && (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="outlined"
                  color="dark"
                  onClick={() => navigate("/insurer-master/insurer-pincode")}
                >
                  Cancel
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={checkAllFields()}
                  onClick={handelSubmit}
                >
                  {pageMode === "add" ? "Submit" : "Edit"}
                </MaterialButton>
              </>
            )}
          </MaterialBox>
        </Card>
      </DashboardLayout>
      <DashboardFooter />
    </>
  );
};

export default InsurerPincodeFrom;
